import React, {PropTypes} from "react";

class PersonalInfo extends React.Component {

  constructor() {
    super();
  }

  render() {
    return (
      <div className="col-md-12">
        <table style={{marginBottom: 0, width: '100%'}} className="table table-bordered">
          <thead>
          <tr>
            <th cellPadding="0" colSpan="4">
              <span className="bold pull-left"> Professional Info</span>

            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td style={{align: 'left', width: '18%'}}>Employee Code :</td>
            <td style={{align: 'left', width: '28%'}}>
              <span id="ContentPlaceHolder1_txtName" className="GenText">{this.props.employee.employeeCode}</span>
            </td>
            <td style={{align: 'left', width: '18%'}}>Date of Joining :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_txtSpouseName"
                    className="GenText">{new Date(this.props.employee.dateOfJoining).toLocaleDateString('en-GB')}</span>
            </td>
          </tr>
          <tr>
            <td style={{align: 'left'}}>Payroll :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB" className="GenText">{this.props.employee.payroll}</span>
            </td>
            <td style={{align: 'left'}}>EmailId Official :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">{this.props.employee.emailId}</span>
            </td>
          </tr>


          <tr>
            <td style={{align: 'left'}}>Designation :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB" className="GenText">{this.props.employee.designation}</span>
            </td>
            <td style={{align: 'left'}}>Department :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">{this.props.employee.department}</span>
            </td>
          </tr>

          <tr>
            <td style={{align: 'left'}}>Function :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB" className="GenText">{this.props.employee.function}</span>
            </td>
            <td style={{align: 'left'}}>Sub Department :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblAnniversary"
                    className="GenText">{this.props.employee.subDepartment}</span>
            </td>
          </tr>

          <tr>
            <td style={{align: 'left'}}>Reporting Manager:</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB"
                    className="GenText">{this.props.employee.reportingTo}&nbsp;&nbsp;{this.props.employee.managerName}</span>
            </td>
            <td style={{align: 'left'}}>Vertical:</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">{this.props.employee.vertical}</span>
            </td>
          </tr>
          <tr>
            <td style={{align: 'left'}}>Vertical Head:</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB"
                    className="GenText">{this.props.employee.verticalHead}&nbsp;&nbsp;{this.props.employee.verticalHeadName}</span>
            </td>
            <td style={{align: 'left'}}>Location:</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB" className="GenText">{this.props.employee.location}</span>
            </td>
          </tr>
          </tbody>
        </table>


      </div>
    );
  }
}

PersonalInfo.propTypes = {};

export default PersonalInfo;





/** WEBPACK FOOTER **
 ** ./src/components/joiningForm/Tables/ProfessionalInfo.js
 **/